import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useHotkeys } from 'react-hotkeys-hook';
import ContextButton from '../ContextButton';
import { getActiveSelectedMenu } from 'ducks/layout';
import { setShowMoveButtonsMenu } from 'ducks/moveButtonsMenu';
import styled from 'styled-components';
import MoveIcon from '@ingka/ssr-icon/paths/arrow-left-arrow-right';

const DisabledText = styled.div`
  display: none;
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

type Props = {
  onClick: () => void;
  size?: 'xsmall' | 'small' | 'medium';
};

const Move = ({ onClick, size }: Props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const selectedGroupId = useSelector(getActiveSelectedMenu)[0];

  // This is needed for the componnent to render with the correct groupId
  useEffect(() => {}, [selectedGroupId]);

  const onMoveClicked = () => {
    dispatch(setShowMoveButtonsMenu(true));
  };

  useHotkeys('backspace', onMoveClicked, [selectedGroupId]);
  useHotkeys('del', onMoveClicked, [selectedGroupId]);

  return (
    <ContextButton
      label={formatMessage({ id: 'storageone.contextMenuMove' })}
      dataTestId="move"
      onClick={onClick}
      ssrIcon={MoveIcon}
      size={size}
    >
      <DisabledText>{formatMessage({ id: 'storageone.contextMenuMove' })}</DisabledText>
    </ContextButton>
  );
};

export default Move;
